export default "__VITE_ASSET__BCoZ3Hj7__"